import { useEffect } from "react"

import { VISIBILITY_STATES } from "~config/constants"
const TRIES = 3
const WAIT_MS = 200

export function useShowHubspotChat(shouldOpen?: boolean) {
    useSetHubspotChatVisibility({
        shouldOpen: Boolean(shouldOpen),
        shouldShow: true,
    })
}

export function useSetHubspotChatVisibility({
    shouldOpen,
    shouldShow,
}: {
    shouldOpen: boolean
    shouldShow: boolean
}) {
    useEffect(() => {
        if (shouldShow) tryToShowHubspotChatNTimes(TRIES, shouldOpen)

        return hideHubspotChat
    }, [])
}

export function showHubspotChat(shouldOpen?: boolean) {
    const didShow = changeHubspotChatVisibility(VISIBILITY_STATES.VISIBLE)

    if (shouldOpen) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO fix eslint
            window.HubSpotConversations?.widget?.open()
        } catch (error) {
            console.error(error)
        }
    }
    return didShow
}

// To reduce the possibility of racing conditions,
// use a time and a set number of times
function tryToShowHubspotChatNTimes(times: number, shouldOpen?: boolean) {
    // If we've tried enough times, bail
    if (times <= 0) return

    // Try to show and bail if shown
    const didShow = showHubspotChat(shouldOpen)

    if (didShow) return

    setTimeout(() => {
        tryToShowHubspotChatNTimes(times - 1)
    }, WAIT_MS)
}

function hideHubspotChat() {
    changeHubspotChatVisibility(VISIBILITY_STATES.HIDDEN)
}

type VisibilityKey = (typeof VISIBILITY_STATES)[keyof typeof VISIBILITY_STATES]

function changeHubspotChatVisibility(visibility: VisibilityKey) {
    const hubspotContainer = document.querySelector<HTMLElement>(
        "body div#hubspot-messages-iframe-container"
    )

    if (hubspotContainer) {
        hubspotContainer.style.visibility = visibility
        return true
    } else {
        console.error(`Could not find the Hubspot container`)
        return false
    }
}
